
<div class="admin">

  <mat-tab-group mat-align-tabs="start" (selectedIndexChange)="selectedTabChange($event)">
    <mat-tab label="Users">
        <app-user-admin></app-user-admin>
    </mat-tab>
    <mat-tab label="Accounts"> 
      <app-table [tableDef]="AccountsDef"></app-table>
    </mat-tab>

    <mat-tab label="Logos"> 
      <app-logo-admin *ngIf="DisplayLogos"></app-logo-admin>
    </mat-tab>    

    <mat-tab label="Action Log"> 
      <div class="message">Last 1000 Actions</div>
      <app-table [tableDef]="ActionLogDef"></app-table>
    </mat-tab>        

    <mat-tab label="Load Data">       
            
      <input type="file" #file placeholder="Choose file" (change)="uploadFile(file.files)" style="display:none;">
      <input type="file" #userfile placeholder="Choose file" (change)="uploadUserFile(userfile.files)" style="display:none;">

      <button style="margin:10px 0 0px 10px" mat-raised-button class="aip-button" (click)="file.click()">Upload Data File</button>      
      <button style="margin:10px 0 20px 10px" mat-raised-button class="aip-button" (click)="userfile.click()">Upload User File</button>      
    
      <mat-progress-bar *ngIf="progress > 0 && progress < 100" mode="determinate" [value]="progress"></mat-progress-bar>
              
      <ng-container *ngIf="this.isLoading">
        <mat-spinner diameter=50 class="spinner"></mat-spinner>
      </ng-container>

      <span class="upload">          
        <div class="upload-message" [innerHTML]="this.message"></div>          
      </span>
    
    </mat-tab>

    <mat-tab label="Export Data">                   
      <button style="margin:10px 0 0px 10px" mat-raised-button class="aip-button" (click)="exportEntityData()">Entity Data</button>          
    </mat-tab>

    <mat-tab label="FAQs"> 
      <app-table [tableDef]="FaqsDef"></app-table>
    </mat-tab>

    <mat-tab label="Admin Reports">
      <app-admin-reports></app-admin-reports>
    </mat-tab>

    <mat-tab label="Stack Layer Color">
      <app-stack-color></app-stack-color>
    </mat-tab>

  <!--  this was to test various connections to EMS data
    <mat-tab label="Test BDM Connection">       
      <button style="margin:10px 0 0px 10px" mat-raised-button class="aip-button" (click)="testBDM()">Test</button>
      <div class="admin-test" [innerHTML]="this.TestData"></div>
    </mat-tab>
    
    <mat-tab label="EMS">             
      <div class="iframeholder">
      <iframe height="100%" width="100%" src="https://app.powerbi.com/reportEmbed?reportId=5a0ca610-e4ab-4b1f-b304-9d9d6cd89155&appId=a2530fdd-5444-4eb5-970d-a51f5f047ff1&autoAuth=true&ctid=93f33571-550f-43cf-b09f-cd331338d086&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D&pageName=ReportSection252b9154c54cda5ba030"></iframe>
    </div>
  </mat-tab>

    <mat-tab label="Power BI Report">             
      <div class="iframeholder">
      <iframe height="100%" width="100%" src="https://app.powerbi.com/reportEmbed?reportId=04324795-5e22-40e3-89cb-983e85000131&appId=a2530fdd-5444-4eb5-970d-a51f5f047ff1&autoAuth=true&ctid=93f33571-550f-43cf-b09f-cd331338d086&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D&pageName=ReportSection252b9154c54cda5ba030"></iframe>
    </div>
  </mat-tab>

    -->

  </mat-tab-group>
  <quill-editor style="display: none;"></quill-editor>
</div>